import styled from "styled-components";
export const TicketsListStyle = styled.div``;
